import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  Box,
  Button,
  Dialog,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import { ReactComponent as Close } from "../assets/svg/Close.svg";
import "../../../Assets/css/kyc.css";
import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useNavigate } from "react-router-dom";

const VerifyEPF = () => {
  const navigate = useNavigate();

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const numOfContainers = 6;
  const [open, setOpen] = useState(false);
  const [EPFNumber, setEPFNumber] = useState("");
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const [eFullName, setEFullName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [masking, setMasking] = useState();
  const inputRefs = useRef([]); // Create an array of refs for each text field
  const [verify, setVerify] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Set dragging state
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files; // Access dropped files
    handleFileChange({ target: { files } }); // Pass files to the handler
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Only handle one file
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Set the image preview to the FileReader result
      };
      reader.readAsDataURL(file);
      console.log("Image preview", imagePreview);
      // Read the file as a data URL for preview
    } else {
      console.log("Please upload a valid image file.");
    }
  };

  const maskingFunction = (number) => {
    if (number <= 4) {
      return number;
    }
    return number.slice(-3).padStart(number.length, "*");
  };

  const handleMasking = (e) => {
    const inputvalue = e.target.value;
    setEPFNumber(inputvalue);

    const masking = maskingFunction(inputvalue);
    setMasking(masking);
  };
  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
  };

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");

  return (
    <>
      <div className="Allcards_full_container p-3">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your EPF Identity</h2>
            {showData ? (
              <p className=" paragraph m-0">
                Upload Your EPF Account Details for Secure Verification
              </p>
            ) : (
              <p className=" paragraph m-0">
                Your EPF Account has been Verified Successfully.
              </p>
            )}

            <div className="d-flex justify-content-center">
              <div>
                {!fileURL && (
                  <>
                    {imagePreview ? (
                      ""
                    ) : (
                      <>
                        <div
                          //   className={`file-upload-container ${
                          //     isDragging ? "dragging" : ""
                          //   }`}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            id="file-input"
                          />

                          <label
                            htmlFor="file-input"
                            className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3"
                          >
                            <Cloud width={80} />
                            <span className="m-0 p-0">
                              {isDragging
                                ? "Drop file here"
                                : "Drag file here or "}
                              <span className="text-primary">Upload File</span>
                            </span>
                            <p>5MB max file size</p>
                          </label>
                        </div>
                      </>
                    )}

                    {imagePreview && (
                      <div className="selectedImage">
                        <img
                          src={imagePreview}
                          alt="Uploaded"
                          style={{ maxWidth: "300px", marginTop: "20px" }}
                        />
                      </div>
                    )}
                  </>
                )}

                {fileURL && (
                  <div className="selectedImage">
                    {file && file.type.startsWith("image/") && (
                      <img
                        src={fileURL}
                        alt="Selected"
                        style={{
                          marginTop: "10px",
                          // maxWidth: "300px",
                          // maxHeight: "300px",
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    {file && file.type === "application/pdf" && (
                      <iframe
                        src={fileURL}
                        title="Selected PDF"
                        style={{
                          marginTop: "10px",
                          width: "100%",
                          height: "500px",
                        }}
                      />
                    )}
                  </div>
                )}
                {file && file.type === "application/pdf" && (
                  <iframe
                    src={fileURL}
                    title="Selected PDF"
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      height: "500px",
                    }}
                  />
                )}
              </div>
              {!imagePreview && (
                <>
                  <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                    <Takephoto />
                    <p className="custom-text-color text-capitalize">
                      Capture Image
                    </p>
                  </Button>
                </>
              )}
            </div>

            {showData && (
              <p className="paragraph">
                Please upload a clear image of your EPF account statement to
                begin the verification process. Our system will <br />
                automatically detect and display your account details.
                Alternatively, you can manually enter the details below.
              </p>
            )}

            {!showData && (
              <div className="d-flex flex-row align-items-center">
                <TextField
                  value={masking}
                  onChange={(e) => setEPFNumber(e.target.value)}
                  label={"EPF Account/UA Number*"}
                  className="m-4"
                  style={{ width: "400px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {verify ? <Verify /> : <NonVerify />}
                      </InputAdornment>
                    ),
                  }}
                />
                {/* <div className="verify d-flex align-items-center">
              {verify ? <Verify /> : <NonVerify />}
            </div> */}
              </div>
            )}

            {!showData && (
              <p className="paragraph">
                Thank you for verifying your EPF account details. Your identity
                has been securely confirmed. You can now
                <br /> proceed to the next steps or return to your dashboard to
                explore other features.
              </p>
            )}

            {showData ? (
              <>
                <TextField
                  inputRef={inputRef}
                  value={eFullName}
                  onChange={(e) => setEFullName(e.target.value)}
                  label={"Employee Full Name*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={EPFNumber}
                  onChange={handleMasking}
                  label={"EPF Account/UA Number*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  type="date"
                  label={"Employment start Date"}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="m-2"
                  style={{ width: "400px" }}
                  InputLabelProps={{
                    shrink: true, // This forces the label to stay shrunk even when the field is empty
                  }}
                />
                <Box sx={{ minWidth: 400 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      EPF Account Status*
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={accountStatus}
                      label="EPF Account Status*"
                      onChange={(e) => setAccountStatus(e.target.value)}
                    >
                      <MenuItem value={10}>Active</MenuItem>
                      <MenuItem value={20}>Inactive</MenuItem>
                      <MenuItem value={30}>Closed</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <TextField
                  value={employerName}
                  onChange={(e) => setEmployerName(e.target.value)}
                  label={"Employer Name*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
              </>
            ) : (
              ""
            )}
            {showData ? (
              <>
                <div className="d-flex flex-row">
                  <Button
                    // variant="contained"
                    className="txtcolor m-3"
                    //   onClick={() => setOpen(true)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className=" btncolor m-3"
                    onClick={() => setVerifiedOpen(true)}
                  >
                    Confirm
                  </Button>
                </div>
              </>
            ) : (
              <Button
                variant="contained"
                className=" btncolor m-3"
                onClick={() =>
                  navigate("/countrySelecting", {
                    state: {
                      SelectedCountry: {
                        label: "India",
                        code: "IN",
                        phone: "91",
                      },
                    }, // Pass the selected country object
                  })
                }
              >
                Back to KYC
              </Button>
            )}

            <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
              <div>
                <div className=" my-2 mx-5 p-2 align-items-center justify-content-center text-center">
                  <Successmsg />
                  <div className="align-items-center justify-content-center text-center">
                    <h6 className="fw-bold">Verification Successful!</h6>
                    <p>Your Passport Details has been successfully verified.</p>
                  </div>
                  {/* <DialogContentText></DialogContentText> */}
                </div>
                <div className=" d-flex justify-content-center m-3">
                  <Button
                    variant="contained"
                    className="btncolor"
                    onClick={() => handleClose()}
                  >
                    continue
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyEPF;
